import { useT } from '../../lib/i18n';

/**
 * Menüdeki "Raporlar ve satın alma" grubu (Faz 8). `Shell.tsx`'e tek satırla eklenir; paralel geliştirmede birleştirme çakışması bu
 * dosyada kalır (ADR-801). Öğeler yetkiye göre süzülür (yetkisi olmayan görmez; grup boşsa gösterilmez).
 */
export function useReportsNavGroup(): {
  group: string;
  items: Array<{ to: string; label: string; permission?: string; anyOf?: string[] }>;
} {
  const t = useT();
  return {
    group: t('admin.reports.navGroup'),
    items: [
      { to: '/satis-raporu', label: t('admin.salesReport.navLabel'), permission: 'reports.sales.read' },
      { to: '/finans-raporu', label: t('admin.financeReport.navLabel'), permission: 'reports.finance.read' },
      {
        to: '/pazarlama-ozeti',
        label: t('admin.marketingSummary.navLabel'),
        permission: 'reports.sales.read',
      },
      { to: '/coklu-dokunus', label: t('admin.multiTouch.navLabel'), permission: 'tracking.read' },
      { to: '/stok-raporu', label: t('admin.stockReport.navLabel'), permission: 'inventory.stock.read' },
      {
        to: '/rapor-olusturucu',
        label: t('admin.reportBuilder.navLabel'),
        permission: 'reports.custom.read',
      },
      { to: '/rapor-dosyalari', label: t('admin.reportFiles.navLabel'), permission: 'reports.custom.read' },
      {
        to: '/finans-girdileri',
        label: t('admin.financeInputs.navLabel'),
        permission: 'reports.finance.read',
      },
      {
        to: '/fiyat-simulasyonu',
        label: t('admin.priceSimulation.navLabel'),
        permission: 'pricing.cost.read',
      },
      { to: '/odeme-itirazlari', label: t('admin.disputes.navLabel'), permission: 'payments.payment.read' },
      { to: '/otomasyon-akislari', label: t('admin.workflows.navLabel'), permission: 'workflows.read' },
      { to: '/satin-alma', label: t('admin.purchasing.navOrders'), permission: 'purchasing.read' },
      { to: '/mal-kabul', label: t('admin.purchasing.navReceive'), permission: 'purchasing.receive' },
      { to: '/tedarikciler', label: t('admin.purchasing.navSuppliers'), permission: 'purchasing.read' },
    ],
  };
}
